module.exports = __webpack_public_path__ + "img/youtube_social_icon_red.fe8ee891.png";